import { get } from "lodash";
import { IAction, IGetValue, IModel, IResult } from "./types";

/**
 * Performs the specified action against the model and optional result optionally using the specified value getter.
 * @param model
 * @param action
 * @param getValue
 * @param result
 * @returns
 */
export const applyFunction = (model: IModel, action: IAction, getValue?: IGetValue, result?: IResult): unknown => {
  /* eslint-disable no-new-func */
  return Function.apply(null, [
    ...action.sources.map((s) => s.split(".").pop() as string),
    `return ${action.expression};`,
  ])(...action.sources.map((s) => (getValue && getValue(s, model)) ?? get(model, s) ?? get(result, s)));
};

/**
 * Evaluates an action against the supplied model and optionally a getter and/or the result.
 * @param model
 * @param action
 * @param getValue
 * @param result
 * @returns
 */
export const evaluate = (model: IModel, action: IAction, getValue?: IGetValue, result?: IResult): boolean => {
  return applyFunction(model, action, getValue, result) as boolean;
};

/**
 * Formats utilizing an action using the supplied model and optionally a getter and/or the result.
 * @param model
 * @param action
 * @param getValue
 * @param result
 * @returns
 */
export const format = (model: IModel, action: IAction, getValue?: IGetValue, result?: IResult): string => {
  try {
    return `${applyFunction(model, action, getValue, result)}`
  } catch (error) {
    return action.expression;
  }
};
